import { IconName } from "PFTheme/graphics/icons";
import { Color } from "PFTypes";

type LegendWarningType = {
  translation: {
    key: "projects.misalignment" | "legend.overbookingLevel";
    variables?: Record<string, number>;
  };
  translationVariables?: object;
  iconName: IconName;
  iconColor: Color;
};

export const basicLegendWarnings: LegendWarningType[] = [
  {
    translation: {
      key: "projects.misalignment"
    },
    iconName: "calendar-delete",
    iconColor: "paletteOrange3"
  },
  {
    translation: {
      key: "legend.overbookingLevel",
      variables: { level: 1 }
    },
    iconName: "warning",
    iconColor: "paletteOrange0"
  },
  {
    translation: {
      key: "legend.overbookingLevel",
      variables: { level: 2 }
    },
    iconName: "warning",
    iconColor: "paletteRed1"
  },
  {
    translation: {
      key: "legend.overbookingLevel",
      variables: { level: 3 }
    },
    iconName: "warning",
    iconColor: "paletteBlack0"
  }
];
